import {
    createSlice, createAsyncThunk
} from '@reduxjs/toolkit';
import {
    ApiViewEntityResponse, ApiViewResponseError, CurrentUserModel
} from '../typings'
import { getBodyErrors } from '../services/ApiService';
import identityService from '../services/IdentityService';

interface CurrentUserState {
    data: CurrentUserModel | null | undefined
}

const initialState: CurrentUserState = {
    data: undefined
}

const currentUserSlice = createSlice({
    name: 'currentUser',
    initialState,
    reducers: {
        currentUserUnloaded: (state) => {
            state.data = undefined
        }
    },
    extraReducers(builder) {
        builder
            .addCase(getCurrentUserData.fulfilled, (state, action) => {
                state.data = action.payload.data;
            })
            .addCase(getCurrentUserData.rejected, (state) => {
                state.data = null;
            })
    }
});

export const getCurrentUserData = createAsyncThunk<ApiViewEntityResponse<CurrentUserModel>, undefined, { rejectValue: ApiViewResponseError[] }>
    ('user/current/data/get', async (_, { rejectWithValue }) => {
        try {
            const response = await identityService.getCurrentUser();
            return response;
        } catch (err: any) {
            return rejectWithValue(await getBodyErrors(err));
        }
    });

export const {
    currentUserUnloaded
} = currentUserSlice.actions;
export default currentUserSlice.reducer
